import { round } from 'lodash';
import { DiscountTypes } from '../types/model.types';

export function getDiscountedAmount(
    value: number,
    discount?: number,
    discount_type?: DiscountTypes
) {
    if (!discount || !discount_type) {
        return value;
    }

    if (discount_type === DiscountTypes.Absolute) {
        return Math.max(0, value - discount);
    }

    if (discount_type === DiscountTypes.Relative) {
        return Math.max(0, value - (discount / 100) * value);
    }

    return Math.max(0, value);
}

export function toFixedIfNotRound(
    number: number,
    fractionDigits: number = 2
): number {
    if (!number) {
        return 0;
    }
    return number % 1 !== 0 ? Number(round(number, fractionDigits)) : number;
}
